import {useUnifyAdminStore} from '../../AdminStore';
import * as StyledComponents from '../StyledComponents';
import get from 'lodash/get';
import {CampaignNameInputWithHelperText} from '../Blocks/CampaignNameInputWithHelperText'
import { t } from 'i18next';

export const CampaignNameEnCAField = (): JSX.Element => {

    /**
     * Data Store
     */
    const campaignItems = useUnifyAdminStore((state) => state.campaignItems);
    const archiveSwitch = useUnifyAdminStore((state) => state.campaignArchiveSwitch);
    const updateCreateCampaignData = useUnifyAdminStore(
        (state) => state.updateCreateCampaignData
    );
    const permissions = useUnifyAdminStore(state => state.permissions);


    const name = get(campaignItems, 'name');

    const handleUpdateNameField = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        return updateCreateCampaignData({
            fieldName: "name",
            value: {enCA: event.target.value, enUS: name?.enUS, frCA: name?.frCA},
        });
    };

    return (
        <StyledComponents.StyledCreateCampaignElementWrapper>
            <CampaignNameInputWithHelperText
                dataTestId="campaign-ca-name-input"
                errorMessage="Please enter Name"
                id="campaign-ca-name-abbr-input"
                inputDivider="left"
                label={t('campaigns.campaignNameEnCA')}
                name="name"
                onChange={handleUpdateNameField}
                placeholder={t('campaigns.campaignNameEnCAPlaceholder')}
                value={campaignItems.name?.enCA}
                customWidth={'100%'}
                isDisabled={archiveSwitch || (campaignItems.id
                    && (!permissions?.hasCampaignUpdatePermissions && !permissions?.hasCampaignSuperAdminPermissions))}
                maxLength={100}
                textLength={`${campaignItems?.name?.enCA?.length || 0}/100`}
            />
        </StyledComponents.StyledCreateCampaignElementWrapper>
    );
};
